import * as React from "react";
import PropTypes from 'prop-types';

const SvgDesktopMenu = props => {
  if (props.id !== "_svgdesktopmenu") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 40 40" {...props}><path d="M8 11h24v2H8zm0 8h24v2H8zm0 8h24v2H8z" fill="#1C2024" fillRule="evenodd" /></svg>;
};

SvgDesktopMenu.displayName = "_svgdesktopmenu";
SvgDesktopMenu.propTypes = {
  id: PropTypes.string
};
SvgDesktopMenu.defaultProps = {
  id: ''
};
export default SvgDesktopMenu;